<template>
  <v-container fluid>
        <v-row>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12" md="12">
            <!-- start of table -->
            <v-data-table
              :items-per-page="pageItems"
              :headers="headers"
              :items="suppliers"
              :search="search"
            >
            <!-- template -->
              <template v-slot:item.AdvancePayment="{ item }">{{ item.AdvancePayment.toLocaleString() }}</template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    pageItems: 100,
    headers: [
      { text: "Supplier Name", value: "Name" },
      { text: "Advance Payments", value: "AdvancePayment" }
    ],
    suppliers: [],
  }),
  methods: {
    getSuppliers() {
      const self = this;
      this.$store
        .dispatch("get", `/suppliers`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.suppliers = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getSuppliers();
  },
};
</script>